module.exports = __webpack_public_path__ + "static/img/VIP.62e18b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VIP.png
// module id = QCYK
// module chunks = 156